import { BROACAST_TEMPLATES_SELECT_TAB } from 'actions/Types';
import { TEMPLATE } from 'constants/Tabs';

export const initialState = {
  currentTab: TEMPLATE
};

export default (state = initialState, action) => {
  if (action.type === BROACAST_TEMPLATES_SELECT_TAB)
    return { ...initialState, currentTab: action.payload };

  return state;
};
